import "../styles/login.css";
import {useState } from "react";
import { API_CONFIG } from "../config/api";


const Login = () => {

  const [mode,setMode]=useState("signup");


  const { host, googleLogin, microsoftLogin } = API_CONFIG;

  const handleGoogleLogin = () => {
    window.location.href = `https://${host}${googleLogin.path}`;
  };

  const handleMicrosoftLogin = () => {
    window.location.href = `https://${host}${microsoftLogin.path}`;
  };

  return (
    <div className="login-page">
      <div className="login-card">
        <h1>{mode==="signup"?"Sign Up":"Log In"}</h1>
        <p> {mode === "signup"
            ? "Create an account to get started"
            : "Welcome back! Sign in to continue"}
        </p>

        <div className="login-buttons">
          <button className="login-btn google" onClick={handleGoogleLogin}>
           <img className="google-img" src="https://upload.wikimedia.org/wikipedia/commons/c/c1/Google_%22G%22_logo.svg" alt="" /> Continue with Google
          </button>

          <button className="login-btn microsoft" onClick={handleMicrosoftLogin}>
           <img className="microsoft-img" src="https://upload.wikimedia.org/wikipedia/commons/4/44/Microsoft_logo.svg" alt="" /> Continue with Microsoft
          </button>
        </div>
      
        {mode === "signup" ? (
          <p>
            Already have an account?{" "}
            <span className="auth-switch" onClick={() => setMode("login")}>Log in</span>
          </p>
        ) : (
          <p>
            Don’t have an account?{" "}
            <span className="auth-switch" onClick={() => setMode("signup")}>Sign up</span>
          </p>
        )}
      </div>
    </div>
  );
};

export default Login;

